import React, { Component } from 'react';
import { URLImgFront } from '../../../config/URLDB';
import ReCAPTCHA from "react-google-recaptcha";
import Loading from '../../Loading';
import { ConsultarCampaniasActiva, ConsultarDatosClienteCampania } from '../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';


const validate = values => {
    const errors = {}
    if (values.tipoIden === 'DEFAULT') {
        errors.tipoIden = 'campo obligatorio'
    }
    if (!values.nit) {
        errors.nit = 'campo obligatorio'
    }
    if (!values.fecExpe) {
        errors.fecExpe = 'campo obligatorio'
    }
    return errors;
};

class Seccion01CooperaGanaMas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showTyCModal: false,
            screenSize: this.getScreenSize(),
            activeButton: null,
            errors: {},
            overlay: false,
            tipoIden: 'DEFAULT',
            ptosAsignados: 'DEFAULT',
            nit: '',
            fecExpe: '',
            stateLoading: false,
            fecSorteo: '',
            infoPtosAsignados: [],
            nombreAso: '',
            valor: 'none',
            valorCheckCamp: 'none',
            estadoSolicitud: true,
            activeBtnConsulta: null
        };

        this.recaptchaRef = React.createRef();
        this.resultadoRef = React.createRef();
    }

    fetchCampActiva = () => {
        const data = {
            tran: 8,
            id_camp: 5
        }

        return ConsultarCampaniasActiva(data)
            .then(response => {
                if (response.data && response.data.length > 0) {
                    if (response.data[0].codresp) {
                        this.setState({ valorCheckCamp: 'none' });
                    }
                    else {
                        this.setState({ valorCheckCamp: 'block' });
                    }
                }
                else {
                    this.setState({ valorCheckCamp: 'none' });
                }
            })
            .catch(error => {
                this.setState({ valorCheckCamp: 'none' });
            });
    };

    ConsultarDatos = () => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });

        //SE VALIDA SI HAY CAMPOS INCOMPLETOS
        if (Object.keys(result).length > 0) {
            if (this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }
            return;
        }

        if (!Object.keys(result).length) {
            this.setState({
                stateLoading: true
            });

            const data = {
                tran: 12,
                tipoiden: this.state.tipoIden,
                nit: this.state.nit,
                fec_exp: this.state.fecExpe,
                id_camp: 31
            }

            ConsultarDatosClienteCampania(data).then(response => {
                try {
                    if (response.data.length > 0) {
                        if (response.data.length >= 1) {
                            if (response.data[0].codresp) {
                                this.setState({
                                    ptosAsignados: 'DEFAULT',
                                    fecSorteo: '',
                                    infoPtosAsignados: [],
                                    nombreAso: '',
                                    valor: 'none',
                                });

                                if (this.recaptchaRef.current) {
                                    this.recaptchaRef.current.reset();
                                }

                                Swal.fire({
                                    icon: 'error',
                                    title: response.data[0].desresp
                                })
                            }
                            else {
                                var fecha = new Date(response.data[0].fecsorteo);
                                this.setState({
                                    valor: 'block',
                                    nombreAso: response.data[0].nomcom,
                                    fecSorteo: fecha.getDate() + "/" + (fecha.getMonth() + 1) + "/" + fecha.getFullYear(),
                                    infoPtosAsignados: response.data,
                                    estadoSolicitud: true,
                                    puntos: response.data[0].puntos
                                }, () => {
                                    if (this.state.valor === 'block' && this.resultadoRef.current) {
                                        this.resultadoRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                    }
                                });
                            }
                        }
                    }
                }
                catch (error) {
                    this.setState({
                        tipoIden: 'DEFAULT',
                        nit: '',
                        fecExpe: '',
                        ptosAsignados: 'DEFAULT',
                        fecSorteo: '',
                        infoPtosAsignados: [],
                        nombreAso: '',
                        valor: 'none',
                        estadoSolicitud: true,
                    });

                    if (this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }

                    Swal.fire({
                        icon: 'error',
                        title: response.data[0].descMessage
                    })
                }

                this.setState({
                    stateLoading: false
                });
            });
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    getScreenSize = () => {
        const width = window.innerWidth;

        if (width <= 480) return 'xs';
        if (width <= 768) return 'sm';
        if (width <= 1025) return 'md';
        if (width > 1025 && width <= 1200) return 'xmd';
        if (width <= 1440) return 'lg';
        if (width <= 1600) return 'xl';
        console.log("ScreenSize:", )
        return 'xxl';
    };

    handleResize = () => {
        const screenSize = this.getScreenSize();
        if (screenSize !== this.state.screenSize) {
            console.log(`Screen size changed to: ${screenSize}`);
            this.setState({ screenSize });
        }
    };

    handleButtonClick = (id) => {
        console.log(`Botón ${id} clickeado`);

        switch (id) {
            case 0: //MODAL DE CONSULTA
                this.openOverlay();
                break;
            case 1: //BOTON COMO PARTICIPAR
                if (this.props.onButtonClick) {
                    this.props.onButtonClick(2);
                }
                break;
            case 2: //BOTON PREMIOS
                if (this.props.onButtonClick) {
                    this.props.onButtonClick(3);
                }
                break;
            case 3: //BOTON TyC
                this.setState({ showTyCModal: true });
                break;
            default:
                break;
        }
    };

    getImageSrc = (screenSize) => {
        switch (screenSize) {
            case 'xs':
            case 'sm':
                return `${URLImgFront}/assets/EstrategiasComerciales/COOPERA_Y_GANA_UTRAHUILCA_SMARTPHONEV2.png`;
            case 'md':
                return `${URLImgFront}/assets/EstrategiasComerciales/smartphone2altV2.png`;
            default:
                return `${URLImgFront}/assets/EstrategiasComerciales/COOPERA_Y_GANA_UTRAHUILCAV2.png`;
        }
    };

    getButtonContainerStyle = (screenSize) => {
        const baseStyle = {
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1
        };

        const screenStyles = {
            xs: {
                top: '51%',
                left: '50%',
                transform: 'translateX(-50%)',
                gap: '1px',
                alignItems: 'center'
            },
            sm: {
                top: '51.5%',
                left: '50%',
                transform: 'translateX(-50%)',
                gap: '1px',
                alignItems: 'center'
            },
            md: {
                top: '50.1%',
                left: '50%',
                transform: 'translateX(-50%)',
                gap: '1px',
                alignItems: 'center'
            },
            xmd: {
                top: '39%',
                right: '9%',
                gap: '1px',
                alignItems: 'flex-end',
            }, 
            lg: {
                top: '39%',
                right: '6%',
                gap: '1px',
                alignItems: 'flex-end',
            },
            xl: {
                top: '40%',
                right: '8%',
                gap: '1px',
                alignItems: 'flex-end'
            },
            xxl: {
                top: '37%',
                right: '8%',
                gap: '1px',
                alignItems: 'flex-end'
            }
        };

        return { ...baseStyle, ...screenStyles[screenSize] };
    };

    getButtonStyle = (screenSize, imageUrl, isActive) => {
        const sizeStyles = {
            xs: { width: '65vw', height: '12vw' },
            sm: { width: '77.35vw', height: '12vw' },
            md: { width: '58vw', height: '10vw' },
            xmd: { width: '40vw', height: '6vw' },
            lg: { width: '48vmin', height: '7.2vmin' },
            xl: { width: '53vmin', height: '9vmin' },
            xxl: { width: '60vmin', height: '11vmin' }
        }

        const scaleUp = screenSize === 'xs' ? 1.19 : 1;
        const scaleActive = isActive ? 0.96 : 1;

        return {
            ...sizeStyles[screenSize],
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            display: 'block',
            margin: 'auto',
            transform: `scale(${scaleUp * scaleActive})`,
            transition: 'transform 0.15s ease',
            cursor: 'pointer'
        };
    };

    openOverlay = () => {
        this.setState({ showOverlay: true });
    };

    closeOverlay = () => {
        this.resetModalForm();
        this.setState({ showOverlay: false });
    };

    textInput = (e) => {
        const { name, value } = e.target;

        if (name === "fecExpe") {
            //SE TOMA EXACTAMENTE EL AÑO
            const yearPart = value.split("-")[0];

            if (yearPart.length > 4) {
                this.setState({ [yearPart]: "" }); return;
            }
        }

        this.setState({ [name]: value });  
    };

    getActiveButton = (isActive) => {
        return {
            outline: 'none',
            display: 'block',
            margin: 'auto',
            transition: 'transform 0.15s ease',
            transform: isActive ? 'scale(0.96)' : 'scale(1)',
            backgroundColor: 'transparent',
            border: 0
        };
    }

    resetModalForm = () => {
        this.setState({
            tipoIden: 'DEFAULT',
            nit: '',
            fecExpe: '',
            errors: {},
            activeBtnConsulta: null,
            puntos: 'DEFAULT',
            valor: 'none'
        });

        if (this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
        }
    };

    validRecat = () => {
        if (this.recaptchaRef.current.getValue()) {
            this.setState({
                estadoSolicitud: false
            })
        } else {
            this.setState({
                estadoSolicitud: true
            })
        }
    }

    render() {
        const { screenSize, activeButton, tipoIden, nit, fecExpe, nombreAso, errors, valor, activeBtnConsulta } = this.state;
        const imageSrc = this.getImageSrc(screenSize);
        const buttonImages = [`${URLImgFront}/assets/EstrategiasComerciales/BotonConsultaPuntos.png`, `${URLImgFront}/assets/EstrategiasComerciales/BotonComoParticipar.png`, `${URLImgFront}/assets/EstrategiasComerciales/BotonPremios.png`, `${URLImgFront}/assets/EstrategiasComerciales/BotonTyC.png` ];

        return (
            <React.Fragment>
                <div id="seccion01" data-aos="fade-up" data-aos-delay="3240"  className={this.state.showOverlay ? "blur-background" : ""}>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <img className="img-fluid" style={{ width: '100%', height: 'auto', display: 'block', touchAction: 'manipulation' }} src={imageSrc} alt="Estrategia Comercial Coopera y Gana Más" />
                        <div
                            className="aos-button-wrapper"
                            data-aos="zoom-in-down"
                            data-aos-delay="3240"
                        >
                        <div style={this.getButtonContainerStyle(screenSize)}>
                            {buttonImages.map((imageUrl, i) => (
                                <div
                                    key={i}
                                    id={`button-${i}`}
                                    data-id={i}
                                    className="button-img"
                                    style={this.getButtonStyle(screenSize, imageUrl, activeButton === i)}
                                    onClick={() => this.handleButtonClick(i)}
                                    onTouchStart={() => this.setState({ activeButton: i })}
                                    onTouchEnd={() => this.setState({ activeButton: null })}
                                    onMouseDown={() => this.setState({ activeButton: i })}
                                    onMouseUp={() => this.setState({ activeButton: null })}
                                    onMouseLeave={() => this.setState({ activeButton: null })}
                                ></div>
                            ))}
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.showOverlay && (
                    <div
                        className="custom-overlay"
                        onClick={this.closeOverlay}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            zIndex: 1000,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '1rem',
                            overflowY: 'auto',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div
                            data-aos="zoom-out"
                            onClick={(e) => e.stopPropagation()}
                            className="overlay-container"
                        >
                            <div className="row align-items-center">
                                <div className="col-12 text-center">
                                    <h2 className="text-white" style={{ fontSize: '3.8vmin' }}>CONSULTA TUS PUNTOS ASIGNADOS A LA FECHA</h2>
                                </div>
                            </div>

                            <div className="row align-items-start pt-4">
                                <div className="col-12 px-2 px-sm-3 px-md-4">
                                    <div className="text-left mb-3">
                                        <h5 className="text-white mb-1 text-overlay-controls">Tipo de documento</h5>
                                        <select name="tipoIden" className="formControlCoopera" value={tipoIden} onChange={this.textInput}>
                                            <option value="DEFAULT" disabled>Seleccione...</option>
                                            <option value="C">CÉDULA CIUDADANÍA</option>
                                            <option value="E">CÉDULA EXTRANJERÍA</option>
                                            <option value="M">PERMISO ESPECIAL DE PERMANENCIA</option>
                                            <option value="N">NIT</option>
                                            <option value="P">PASAPORTE</option>
                                        </select>
                                        {errors.tipoIden && <strong className="text-danger small">{errors.tipoIden}</strong>}
                                    </div>
                                    <div className="text-left mb-3">
                                        <h5 className="text-white mb-1 text-overlay-controls">Número de documento</h5>
                                        <input name="nit" type="text" className="formControlCoopera" value={nit} maxLength="20" onChange={this.textInput} />
                                        {errors.nit && <strong className="text-danger small">{errors.nit}</strong>}
                                    </div>
                                    <div className="text-left mb-3">
                                        <h5 className="text-white mb-1 text-overlay-controls">Fecha expedición</h5>
                                        <input name="fecExpe" type="date" className="formControlCoopera" value={fecExpe} onChange={this.textInput} />
                                        {errors.fecExpe && <strong className="text-danger small">{errors.fecExpe}</strong>}
                                    </div>
                                    <div className="pt-3 d-flex justify-content-center">
                                        <form onSubmit={this.onSubmit} >
                                            <ReCAPTCHA
                                                ref={this.recaptchaRef}
                                                sitekey="6LfTTPgbAAAAAOKQp-b36jm-sJGpLIKw8cnZTzu-"
                                                onChange={this.validRecat}
                                            />
                                        </form>
                                    </div>
                                    <div className="d-flex justify-content-center pt-3" disabled={this.state.estadoSolicitud}>
                                        <button className="button-img border-0 bg-transparent" id={"btnConsultar"} data-id={0} onClick={this.ConsultarDatos} style={this.getActiveButton(activeBtnConsulta === 0)} onTouchStart={() => this.setState({ activeBtnConsulta: 0 })}
                                            onTouchEnd={() => this.setState({ activeBtnConsulta: null })} onMouseDown={() => this.setState({ activeBtnConsulta: 0 })}
                                            onMouseUp={() => this.setState({ activeBtnConsulta: null })} onMouseLeave={() => this.setState({ activeBtnConsulta: null })}>
                                            <img src={`${URLImgFront}/assets/EstrategiasComerciales/Boton_consultar.png`} alt="Consultar" className="btn-consultar-Coopera" />
                                        </button>
                                    </div>

                                    <div style={{ display: valor, scrollMarginTop: '16px' }} ref={this.resultadoRef}>
                                        <div className="row">
                                            <div className="col-12 text-center">
                                                <span className="text-white overlay-span"> {nombreAso} </span>
                                            </div>
                                        </div>
                                        <div className="row pt-2">
                                            <div className="col-12 d-flex align-items-center">
                                                <h2 className="text-white mb-0" style={{ fontSize: '3.8vmin' }}>PUNTOS ASIGNADOS: &nbsp;</h2>
                                                <div className="text-center flex-fill">
                                                    <input type="text" value={this.state.puntos} disabled className="formControlCoopera text-center puntos-cooperaGanaMas" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.stateLoading ? (
                                <Loading />
                            ) : (<React.Fragment></React.Fragment>)}
                        </div>
                    </div>
                )}

                {this.state.showTyCModal && (
                    <div className="tyc-overlay" data-aos="zoom-in" onClick={() => this.setState({ showTyCModal: false })}>
                        <div className="tyc-modal" onClick={(e) => e.stopPropagation()}>
                            <h5 className="text-center">Términos y Condiciones</h5>
                            <iframe
                                src={`${URLImgFront}/assets/Archivos/TermYCondiciones_CooperaGanaMasUTRAHUILCA.pdf#toolbar=0`}
                                width="100%"
                                height="95%"
                                style={{ border: 'none', borderRadius: '10px' }}
                                title="Términos y Condiciones"
                            ></iframe>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default Seccion01CooperaGanaMas;